export const PROFESSIONAL_ROLE_OPTIONS = [
    { value: 'apprentice', label: 'Apprentice' },
    { value: 'journeyman', label: 'Journeyman' },
    { value: 'seniorContractor', label: 'Senior Contractor' },
    { value: 'projectManager', label: 'Project Manager' },
    { value: 'businessOwner', label: 'Business Owner' },
    { value: 'instructorCoach', label: 'Instructor / Coach' },
    { value: 'inspector', label: 'Inspector' },
    { value: 'designerArchitectEngineer', label: 'Designer / Architect / Engineer' },
    { value: 'specialist', label: 'Specialist' },
    { value: 'master', label: 'Master' }
];